
export const VALUATION_MODEL_STEPS = [
	{ label: 'Escoge tus Factores' },
	{ label: 'Ponderación de Factores' },
	{ label: 'Grados' },
	{ label: 'Presupuesto de Nómina' },
];

export default {};



// WEBPACK FOOTER //
// ./src/modules/job-evaluation/constants/constants.js